import {h, Component} from 'preact';
import ReactHtmlParser from 'react-html-parser';
import { CheckboxWithLabel } from '../checkbox-with-label/checkbox-with-label';
import PasswordStrength from './password-strength';
import alertIcon from '../../img/icon-alert-yellow.png';
import alertIcon2 from '../../img/icon-alert-yellow@2x.png';
import alertIcon3 from '../../img/icon-alert-yellow@3x.png';

export class CreatePasswordInput extends Component {
    constructor() {
        super();
        this.state = {
            selfCreatedPassword: '',
            showPassword: false,
            passwordCharactersMatch: false,
            passwordLowercaseMatch: false,
            passwordUppercaseMatch: false,
            passwordNumberMatch: false,
            passwordSpecialMatch: false,
            passwordMustMatch: false,
            isGoodPassword: false,
            passwordError: ''
        }
    }

    componentDidMount() {
        this.passwordInput.focus();
        this.setState({ passwordError: this.props.passwordError, username: this.props.username });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.passwordError !== nextProps.passwordError) {
            this.setState({ passwordError: nextProps.passwordError });
        }

        if (this.props.username !== nextProps.username) {
            this.setState({ username: nextProps.username });
        }
    }

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    onPasswordInput = e => {
        const selfCreatedPassword = e.target.value;
        this.setState({ selfCreatedPassword, passwordError: '' });
        this.validatePassword();
    };

    onPasswordVerifyInput = e => {
        const selfCreatedPasswordVerify = e.target.value;
        this.setState({ selfCreatedPasswordVerify, passwordError: '' });
        this.validatePassword();
    };

    submitForm = e => {
        e.preventDefault();
        if (this.state.isGoodPassword) {
            this.props.action(this.state.selfCreatedPassword);
        }
    };

    validatePassword = () => {
        const password = this.state.selfCreatedPassword;
        const passwordCharactersMatch =  password.length >= this.props.minLength;
        const passwordLowercaseMatch =  !!/[a-z]+/.test(password);
        const passwordUppercaseMatch =  !!/[A-Z]+/.test(password);
        const passwordNumberMatch =  !!/\d+/.test(password);
        const passwordSpecialMatch =  !!/[!@$%^&*()_+,.?`~{}\\|\/?<>;'"\[\]=-]+/.test(password) && !/[#:]+/.test(password);
        const passwordMustMatch = this.state.selfCreatedPasswordVerify === this.state.selfCreatedPassword;
        const isGoodPassword = passwordCharactersMatch && passwordLowercaseMatch && passwordNumberMatch && passwordSpecialMatch && passwordUppercaseMatch && passwordMustMatch;
        this.setState({passwordCharactersMatch, passwordLowercaseMatch, passwordUppercaseMatch, passwordNumberMatch, passwordSpecialMatch, passwordMustMatch, isGoodPassword});
        this.props.setPasswordValidation(isGoodPassword);
        this.props.setPassword(password);
    };

    render({minLength}, {selfCreatedPassword, selfCreatedPasswordVerify, showPassword, passwordCharactersMatch, passwordLowercaseMatch, passwordUppercaseMatch, passwordNumberMatch, passwordSpecialMatch, passwordMustMatch, isGoodPassword, passwordError, username}) {
        return(
            <div className='create-password-input'>
                <div className='clearfix'>
                    <h4>{typeof username === 'undefined' ? 'Type a new password that uses the recommended security rules below:' : ReactHtmlParser(`Type a password for your Workplace account <span><span class="username">(${username}</span>):</span>`) }</h4>
                    <form onSubmit={this.submitForm} className='d-flex flex-column'>
                        <input type={showPassword ? 'text' : 'password'}
                               ref={passwordInput => this.passwordInput = passwordInput}
                               className='form-control'
                               id='new-password-field'
                               placeholder='Create your new password'
                               value={selfCreatedPassword}
                               onInput={this.onPasswordInput}
                        />
                        {passwordError ? (
                            <div className='error-message'>
                                <img src={alertIcon} srcSet={`${alertIcon2} 2x, ${alertIcon3} 3x`} alt='alert'/><span>{passwordError}</span>
                            </div>
                        ) : (
                            <PasswordStrength password={selfCreatedPassword} minLength={minLength} />
                        )}
                        <div className='password-verify'>
                            <input type={showPassword ? 'text' : 'password'}
                                   className='form-control'
                                   id='new-password-verify-field'
                                   placeholder='Verify password'
                                   value={selfCreatedPasswordVerify}
                                   onInput={this.onPasswordVerifyInput}
                            />
                            <CheckboxWithLabel label='Show password' checked={showPassword} action={this.toggleShowPassword}/>
                        </div>
                        <input type='submit' className='hidden'/>
                    </form>
                </div>
                <p className='title'>Make sure your password:</p>
                <ul>
                    <li className={passwordCharactersMatch ? 'highlighted' : ''}>
                        is at least {minLength} characters long
                    </li>
                    <li className={passwordLowercaseMatch ? 'highlighted' : ''}>
                        contains one or more lowercase letters
                    </li>
                    <li className={passwordUppercaseMatch ? 'highlighted' : ''}>
                        contains one or more uppercase letters
                    </li>
                    <li className={passwordNumberMatch ? 'highlighted' : ''}>
                        contains one or more numbers
                    </li>
                    <li className={passwordSpecialMatch ? 'highlighted' : ''}>
                        contains one or more special characters (except &lsquo;#&rsquo;, &lsquo;:&rsquo;)
                    </li>
                    <li className={passwordMustMatch ? 'highlighted' : ''}>
                        passwords must match
                    </li>
                </ul>
                <p className={`note`}>For your security, never use this password on any other site or app. </p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/@webapp/preact-shared/components/create-password-input/create-password-input.js